"use client"

import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon } from "lucide-react"

import { cn } from "@/lib/utils"

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "cy:peer cy:size-4.5 cy:shrink-0 cy:rounded-[2px] cy:border-2 cy:border-[#49454F] cy:bg-white cy:transition-all cy:outline-none cy:focus-visible:ring-2 cy:focus-visible:ring-primary cy:focus-visible:ring-offset-2 cy:disabled:cursor-not-allowed cy:disabled:opacity-50 cy:data-[state=checked]:bg-primary cy:data-[state=checked]:border-primary",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="cy:flex cy:items-center cy:justify-center cy:text-white cy:transition-none"
      >
        <CheckIcon className="cy:size-3.5 cy:font-bold" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
